/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bytes: NonNullable<unknown>, tool: NonNullable<unknown> }} Chat_Tool_Content_From_Other_SystemInputs */



/**
* | output |
* | --- |
* | "Content from another system: {bytes} bytes read earlier by {tool}" |
*
* @param {Chat_Tool_Content_From_Other_SystemInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_content_from_other_system = /** @type {((inputs: Chat_Tool_Content_From_Other_SystemInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Content_From_Other_SystemInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Inhalt aus einem anderen System: ${i?.bytes} Bytes, zuvor gelesen von ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Content from another system: ${i?.bytes} bytes read earlier by ${i?.tool}`)
});